module.exports = __webpack_public_path__ + "static/media/218-Milo-Fragen_ID_3.aa64f3e5.mp3";